/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import { Dictionary, SafeDictionary } from "@insite/client-framework/Common/Types";

type UserData = {
    isAuthenticated: boolean;
    currentCurrency?: string;
    currentLanguage?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    country?: string;
    state?: string;
    company?: string;
};

export const mapUserData = (
    userData: UserData,
    fieldsMapping: string,
    isInShell?: boolean,
    modalLocationAddress?: LocationModel & { properties: Dictionary<string> },
    comingFromDealerPage?: boolean,
): SafeDictionary<any> => {
    // fieldsMapping format example ("firstName:FirstName,lastName:LastName")
    const MappedObject: SafeDictionary<any> = {};
    let productPartNumber: string;
    let pageUrl: string;
    const parsedFields = fieldsMapping.split(",");
    if (parsedFields.length === 0) {
        return {};
    }
    if (!isInShell) {
        // Get productNumber from localStorage
        if (typeof window !== "undefined") {
            productPartNumber = localStorage?.getItem("productPartNumber") || "";
            pageUrl = window?.location.href || "";
        }
    }

    if (!userData.isAuthenticated) {
        parsedFields.map(item => {
            const attributes = item.split(":");
            if (attributes.length > 1) {
                const marketoKey = attributes[1].trim();
                const optiKey = attributes[0].trim();

                MappedObject[marketoKey] = "";

                if (optiKey.toLocaleLowerCase().includes("page")) {
                    MappedObject[marketoKey] = pageUrl;
                }

                if (optiKey.toLocaleLowerCase().includes("product")) {
                    MappedObject[marketoKey] = productPartNumber;
                }

                if (modalLocationAddress && comingFromDealerPage) {
                    if (optiKey.toLocaleLowerCase().includes("dealername")) {
                        MappedObject[marketoKey] = modalLocationAddress.name || "";
                    }

                    if (optiKey.toLocaleLowerCase().includes("dealeremail")) {
                        MappedObject[marketoKey] = modalLocationAddress.properties?.["email"] || "";
                    }
                }

                if (optiKey.toLocaleLowerCase().includes("language")) {
                    MappedObject[marketoKey] = userData[optiKey as keyof UserData] || "English";
                }

                if (optiKey.toLocaleLowerCase().includes("currency")) {
                    MappedObject[marketoKey] = userData[optiKey as keyof UserData] || "USD";
                }
            }

            return true;
        });

        return MappedObject;
    }

    parsedFields.map(item => {
        const attributes = item.split(":");
        if (attributes.length > 1) {
            const optiKey = attributes[0].trim();
            const marketoKey = attributes[1].trim();
            if (optiKey in userData) {
                MappedObject[marketoKey] = userData[optiKey as keyof UserData] || "";
            }
            if (optiKey.toLocaleLowerCase().includes("page")) {
                MappedObject[marketoKey] = pageUrl;
            }

            if (optiKey.toLocaleLowerCase().includes("product")) {
                MappedObject[marketoKey] = productPartNumber;
            }

            if (modalLocationAddress && comingFromDealerPage) {
                if (optiKey.toLocaleLowerCase().includes("dealername")) {
                    MappedObject[marketoKey] = modalLocationAddress.name || "";
                }

                if (optiKey.toLocaleLowerCase().includes("dealeremail")) {
                    MappedObject[marketoKey] = modalLocationAddress.properties?.["email"] || "";
                }
            }
        }
        return true;
    });

    return MappedObject;
};
